import { useClient } from '@composables/use-clients';
import { PostRequestArgsType } from '@api/v1/types';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type EmailAvailabilitySerializer = {
  email: string;
  isAvailable: boolean;
};

export type PostEmailAvailabilityPayloadType = (
  Pick<EmailAvailabilitySerializer, 'email'>
);
export type PostEmailAvailabilityResponseType = (
  Pick<EmailAvailabilitySerializer, 'isAvailable'>
);

export const apiCheckEmailAvailability = async ({
  payload,
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<PostEmailAvailabilityPayloadType>) => {
  const impl = async () => {
    const { client } = useClient('public');
    const res = await client.post({
      url: urls.v1.emailAvailability(),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
